import { render, staticRenderFns } from "./RelatedNetworks.vue?vue&type=template&id=2def087e&"
import script from "./RelatedNetworks.vue?vue&type=script&lang=js&"
export * from "./RelatedNetworks.vue?vue&type=script&lang=js&"
import style0 from "./RelatedNetworks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports